import React from 'react'
import DatabaseComponent from '../Components/DatabaseComponent'

const DatabasePage = () => {
  return (
    <DatabaseComponent />
  )
}

export default DatabasePage